import { AnySchema } from 'yup';
import { CXFlow } from '~/components/ClientExperience/OneFlow/models/cx-flow.model';
import { CXPage } from '~/components/ClientExperience/OneFlow/models/cx-page.model';
import { FlowViewUiStore } from '~/components/ClientExperience/OneFlow/stores/flow-view.ui.store';
import { CxFlowStore } from '~/components/ClientExperience/OneFlow/stores/cx-flow.store';

export enum ValidationErrorTypes {
    SmartField = 'smart_field',
    Signature = 'signature',
    PendingSignature = 'pending_signature',
    RequiredQuestion = 'required_question',
    Selection = 'selected_services',
    PendingSelection = 'services_pending_approval',
    ChargeBlock = 'transaction_id',
    PendingInvoice = 'invoice_pending_approval',
    ScheduleSession = 'schedule_session',
    EmailInput = 'email_input',
    URLInput = 'url_input',
    NumberInput = 'number_input'
}

export interface IValidation extends AnySchema {
    message?: string;
}

export interface IValidator {
    id?: string;
    validator?: IValidation;
}

export interface IGetFormikPropsParams {
    selectedFlow: CXFlow;
    selectedPage: CXPage;
    flowViewUiStore: FlowViewUiStore;
    flowStore: CxFlowStore;
    currUserId?: string;
    skipValidation?: boolean;
    isPreview?: boolean;
}
